import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import APP from 'stores/APP';

const BindSuccess: React.FC<{ type: 'email' | 'phone' }> = ({ type }) => {
    const isEmail = type === 'email';

    const handleClick = () => {
        isEmail
            ? APP.trackEvent('安全中心', '邮箱认证_去设置', '邮箱去设置_个人中心')
            : APP.trackEvent('安全中心', '手机认证_去设置', '去设置_个人中心');
    };

    return (
        <div className="account-bind-success">
            <p className="desc">
                {isEmail
                    ? __('您的邮箱已认证，可直接使用邮箱作为TradeUP登录名')
                    : __('您的手机号已认证，可直接使用手机号作为TradeUP登录名')}
            </p>
            <Link onClick={handleClick} to="/profile">
                <CardButtonWrap>
                    <Button size="large" type="primary">
                        {__('个人中心')}
                    </Button>
                </CardButtonWrap>
            </Link>
        </div>
    );
};

export default BindSuccess;
